// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/bg-flow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public//images/bg-flow-light.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.App {
    font-family: sans-serif;
    text-align: center;
  }
  /* Center the input field */

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh; /* This centers the content vertically on the page */
  }
  
  input[type="text"] {
    width: 400px; 
    height: 30px;/* You can adjust the width as needed */
    border-radius: 5px;/* Center text in the input field */
    border: 1px solid #DDDDDD;
    padding: 2px 6px;
    margin-top: 30px;
    z-index: 1000;
  }
  
  /* Style the button */
  button {
    width: 150px;
    height: 40px;
    margin-top: 40px; 
    border-radius: 5px;
    font-size: 14px;
    border: none;
    outline: none;
    align-self: flex-start;
    color: rgb(233, 226, 239);
    background-color: rgb(209,25,25);
    background: linear-gradient(to top right, #b92727 40%, rgba(37,37,37,0.7) 100%);
    z-index: 1000;
  }
  

  .modal-container {
    background-color: white;
    z-index: 10;
    border-radius: 10px;
    overflow: hidden;
    width: fit-content;
    height: fit-content;
    padding: 50px 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  @media only screen and (max-width: 480px) {
    .container{
      padding: 0 5px;
    }
  
    .modal-container {
      padding: 50px 20px;
    }


    input[type="text"] {
      width: 300px; 
      height: 30px;
    }

    button{
      align-self: center;
      margin-bottom: 20px;
    }

    h1{
      font-size: 20px;
      margin-top: 50px;
    }

  }
  @media only screen and (min-width: 480px) and (max-width: 600px) {
    .container{
      padding: 0 5px;
    }
  
    .modal-container {
      padding: 50px 30px;
    }


    input[type="text"] {
      width: 400px; 
      height: 30px;
    }

    button{
      margin-bottom: 20px;
    }

    h1{
      font-size: 25px;
      margin-top: 50px;
    }

  }

  h1 {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    letter-spacing: 0.1em;
    color: #434343;
}

.rec-top{
  position: absolute;
  top: 0;
  left: 0;
}

.rec-bottom{
  position: absolute;
  bottom: 0;
  right: 0;
}

.recaptcha{
  align-self: flex-start;
  margin-top: 20px;
  z-index: 1000;
  width: 10px;
}


.logo {
  align-self: flex-start;
  justify-self: flex-start;
  position: absolute;
  top: 10px;
  width: 300px;
}
.wait-message {
  color: red;
  padding-top: 8px; 
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;EACpB;EACA,2BAA2B;;AAE7B;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,4FAAuF;IACvF,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa,EAAE,oDAAoD;EACrE;;EAEA;IACE,YAAY;IACZ,YAAY,CAAC,uCAAuC;IACpD,kBAAkB,CAAC,mCAAmC;IACtD,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,+EAA+E;IAC/E,aAAa;EACf;;;EAGA;IACE,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;;IAGA;MACE,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;EAEF;EACA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;;IAGA;MACE,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;EAEF;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;;AAGA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.App {\n    font-family: sans-serif;\n    text-align: center;\n  }\n  /* Center the input field */\n\n.container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: url('/public/images/bg-flow.svg'), url('/public//images/bg-flow-light.svg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 100vh; /* This centers the content vertically on the page */\n  }\n  \n  input[type=\"text\"] {\n    width: 400px; \n    height: 30px;/* You can adjust the width as needed */\n    border-radius: 5px;/* Center text in the input field */\n    border: 1px solid #DDDDDD;\n    padding: 2px 6px;\n    margin-top: 30px;\n    z-index: 1000;\n  }\n  \n  /* Style the button */\n  button {\n    width: 150px;\n    height: 40px;\n    margin-top: 40px; \n    border-radius: 5px;\n    font-size: 14px;\n    border: none;\n    outline: none;\n    align-self: flex-start;\n    color: rgb(233, 226, 239);\n    background-color: rgb(209,25,25);\n    background: linear-gradient(to top right, #b92727 40%, rgba(37,37,37,0.7) 100%);\n    z-index: 1000;\n  }\n  \n\n  .modal-container {\n    background-color: white;\n    z-index: 10;\n    border-radius: 10px;\n    overflow: hidden;\n    width: fit-content;\n    height: fit-content;\n    padding: 50px 80px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n  }\n\n  @media only screen and (max-width: 480px) {\n    .container{\n      padding: 0 5px;\n    }\n  \n    .modal-container {\n      padding: 50px 20px;\n    }\n\n\n    input[type=\"text\"] {\n      width: 300px; \n      height: 30px;\n    }\n\n    button{\n      align-self: center;\n      margin-bottom: 20px;\n    }\n\n    h1{\n      font-size: 20px;\n      margin-top: 50px;\n    }\n\n  }\n  @media only screen and (min-width: 480px) and (max-width: 600px) {\n    .container{\n      padding: 0 5px;\n    }\n  \n    .modal-container {\n      padding: 50px 30px;\n    }\n\n\n    input[type=\"text\"] {\n      width: 400px; \n      height: 30px;\n    }\n\n    button{\n      margin-bottom: 20px;\n    }\n\n    h1{\n      font-size: 25px;\n      margin-top: 50px;\n    }\n\n  }\n\n  h1 {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    color: #434343;\n}\n\n.rec-top{\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.rec-bottom{\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.recaptcha{\n  align-self: flex-start;\n  margin-top: 20px;\n  z-index: 1000;\n  width: 10px;\n}\n\n\n.logo {\n  align-self: flex-start;\n  justify-self: flex-start;\n  position: absolute;\n  top: 10px;\n  width: 300px;\n}\n.wait-message {\n  color: red;\n  padding-top: 8px; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
